import React from "react";
import KeyMetrics from "./KeyMetrics";
import StatusBreakdown from "./StatusBreakdown";
import CountryStats from "./CountryStats";
import SystemInfo from "./SystemInfo";
import { OrderStats, User } from "./types";

interface AdminDashboardProps {
  stats: OrderStats | null;
  currentUser?: User;
}

const AdminDashboard: React.FC<AdminDashboardProps> = ({
  stats,
  currentUser,
}) => {
  return (
    <>
      {/* Key Metrics - Regular metrics for admin/manager roles */}
      <KeyMetrics stats={stats} currentUser={currentUser} />

      {/* Status Breakdown and Country Stats */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
        <StatusBreakdown stats={stats} currentUser={currentUser} />
        <CountryStats stats={stats} currentUser={currentUser} />
      </div>

      {/* System Information */}
      <SystemInfo stats={stats} currentUser={currentUser} />
    </>
  );
};

export default AdminDashboard;
